<template>
  <div>
    <Head title="Productos" />
    <h1 class="mb-8 text-3xl font-bold">Lote de cargas</h1>
    <div class="bg-white rounded-xl shadow overflow-x-auto py-10">
      <div class="p-5">
        <h3>Buscar ordenes</h3>
      </div>
      
      <div class="px-10">
        <div class="flex">
        <text-input label="Por Términos" class="pb-8 pr-6 w-full lg:w-1/2" v-model="form.search.number_order" />
      </div>
      <div class="overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr>
            <th>Numero</th>
            <th>Cliente</th>
            <th>Observación</th>
            <th>Total</th>
          </tr>
          <tr v-for="(order, key) in orders.data" :key="key" class="hover:bg-gray-100 focus-within:bg-gray-100" @click="addProduct(order)">
            <td class="p-2 text-center">{{ order?.number_order }}</td>
            <td class="p-2 text-center">{{ order?.client?.name }}</td>
            <td class="p-2 text-center">{{ order?.comentary }}</td>
            <td class="p-2 text-center">{{order?.total}}</td>
          </tr>
        </table>
      </div>
      </div>


      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-3">Numero</th>
          <th class="pb-4 pt-6 px-3">Cliente</th>
          <th class="pb-4 pt-6 px-6">Total</th>
          <th class="pb-4 pt-6 px-6">Bultos</th>
        </tr>
        <tr v-for="(order, key) in items" :key="key" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link :href="`orders/${order.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ order.number_order }}
            </Link>
          </td>
          <td class="border-t">
            <Link :href="`orders/${order.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ order.client.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link :href="`orders/${order.id}`" class="flex items-center px-6 py-4 focus:text-indigo-500">
              {{ order.total }}
            </Link>
          </td>
          <td class="border-t">
            <text-input v-model="form.orders[key].package" type="number" class="w-full lg:w-1/2" />
          </td>
          <td class="border-t">
            <button @click="removeProduct(order)" class="btn btn-danger">
              <i class="fa fa-trash"></i>
            </button>
          </td>
          
        </tr>
        <tr v-if="!orders">
          <td class="px-6 py-4 border-t" colspan="4">No hay ordenes.</td>
        </tr>
      </table>

      <div class="px-10 py-10">
        <select-input v-model="form.transport" label="Transporte">
          <option value="">Seleccionar</option>
          <option value="apj">APJ</option>
          <option value="syt">S&T</option>
          <option value="internal">Interno</option>
          <option value="retira-cliente">Retira Cliente</option>
        </select-input>
        <select-input v-model="form.region" label="Region">
          <option value="Amazonas">Amazonas</option>
          <option value="Anzoátegui">Anzoátegui</option>
          <option value="Apure">Apure</option>
          <option value="Aragua">Aragua</option>
          <option value="Barinas">Barinas</option>
          <option value="Bolívar">Bolívar</option>
          <option value="Carabobo">Carabobo</option>
          <option value="Cojedes">Cojedes</option>
          <option value="Delta Amacuro">Delta Amacuro</option>
          <option value="Distrito Capital">Distrito Capital</option>
          <option value="Falcón">Falcón</option>
          <option value="Guárico">Guárico</option>
          <option value="Lara">Lara</option>
          <option value="Mérida">Mérida</option>
          <option value="Miranda">Miranda</option>
          <option value="Monagas">Monagas</option>
          <option value="Nueva Esparta">Nueva Esparta</option>
          <option value="Portuguesa">Portuguesa</option>
          <option value="Sucre">Sucre</option>
          <option value="Táchira">Táchira</option>
          <option value="Trujillo">Trujillo</option>
          <option value="Vargas">Vargas</option>
          <option value="Yaracuy">Yaracuy</option>
          <option value="Zulia">Zulia</option>
        </select-input>
      </div>
      <loading-button class="btn-blue mx-4 my-4" type="button" @click="generate">Crear lote de carga</loading-button>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import pickBy from 'lodash/pickBy'
import SelectInput from '@/Shared/SelectInput.vue'

export default {
  components: {
    Head,
    Link,
    TextInput,
    SelectInput,
  },
  layout: Layout,
  props: {
    orders: Object,
  },
  data() {
    return {
      getQuantity(inventory)
      {
        let quantity = 0
        for (let inventory of inventory) {
          quantity += inventory.quantity
        }

        return quantity
      },
      quantities: this.$inertia.form({
        qtys: [],
        products: [],
        deposits: [],
      }),
      form: this.$inertia.form({
        code: '',
        search: {
          number_order: ''
        },
        orders: [],
        transport: '',
        region: '',
        package: 0
      }),
      prd: {
        name: '',
      },
      items: []
    }
  },
  watch: {
    'form.search.number_order': function () {
      this.onSearchProductsChange()
    },
    'form.search.deposit': function () {
      this.onSearchProductsChange()
    },
    'form.search.brand_id': function () {
      this.onSearchProductsChange()
    },
    'form.search.part_id': function () {
      this.onSearchProductsChange()
    },
    'form.search.truck_model_id': function () {
      this.onSearchProductsChange()
    },
    'form.search.region_id': function () {
      this.onSearchProductsChange()
    },
  },
  methods: {
    removeProduct(product) {
      if (confirm('Estas seguro que quieres eliminar este item?')) {
        let products = this.items
        let newProducts = products.filter((prd) => prd.id != product.id)
        this.items = newProducts
      }
    },
    onSearchProductsChange() {
      this.$inertia.get('/loads/create', pickBy({search: this.form.search}), {
        preserveState: true,
        preserveScroll: true,
        replace: true
      })
    },
    generate() {
      this.form.post('/loads')
    },
    addProduct(order) {
        this.form.orders.push(order);
        this.items.push(order);
    },
  },
}
</script>
